import { c as _c } from "react/compiler-runtime";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useSearchBox } from 'react-instantsearch';
import { Input, InputGroup } from '@/frontend/design-system/forms/Input';
export function CustomSearchBox() {
  const $ = _c(6);
  const {
    query,
    refine
  } = useSearchBox();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MagnifyingGlassIcon className="h-5 w-5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== refine) {
    t1 = e => refine(e.target.value);
    $[1] = refine;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== query || $[4] !== t1) {
    t2 = <InputGroup>{t0}<Input value={query} onChange={t1} placeholder={"Wyszukaj artyku\u0142..."} /></InputGroup>;
    $[3] = query;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}